module.exports = __webpack_public_path__ + "Poppins-Light.b2b23d2504016419aa88.ttf";


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/assets/fonts/Poppins-Light.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Light.ttf
// module chunks = styles